import axios from "axios";
import { API_ENDPOINT_BASE_URL } from "./constants";
import { getUser } from "./helpers";

export const getQueueInfo = async (user, q_uuid) => {
  const url = API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/get_cc_queue_name/";
  try {
    if (!user) {
      return [];
    }
    const params = { user_id: user.user_id, q_uuid: q_uuid };
    const response = await axios.get(url, { params: params });
    return response.data;
  } catch (error) {
    return { dialer_type: "sequential" };
  }
};

export const getDialerTypeOfQueue = async (q_uuid) => {
  try {
    const data = await getQueueInfo(getUser(), q_uuid);
    return data["dialer_type"];
  } catch (error) {
    return "sequential";
  }
};
